import "./Settings.css";
import { useState, useEffect, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomButton from "../../Components/Reusable/Button/CustomButton";
import BackButton from "../../Components/Reusable/BackButton/BackButton";
import PoliciesPage from "./PolicySection";
import ColorPickerField from "../../Components/ColourPicker/ColourPicker";
import { FaExclamationTriangle } from "react-icons/fa";
import {
  UpdateBookingPortalStatus
} from "../OnlineBooking/Requests";
import {
  GetConfig,
  PutAppointmentsConfig,
  PutLangConfig,
  PutAccountDetailsConfig,
  ResetDemoAccount,
  PutCustomerisationCommunicationsConfig,
  SendTestConfirmationEmail,
  PutNotificationsConfig,
  VerificationCode,
  UpdateEmail,
  UpdatePassword,
  GetPaymentServiceDetails,
  PutCalendarConfig,
  GetMembershipDetails,
  GetAllowedPlans,
  CreateBillingPortalSession
} from "./Requests";
import MyAlert from "../../Components/Reusable/Alert/Alert"
import { notifyError, notifySuccess, notifyWarn } from "../../Response/ResposeHandler";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Payments from "../../Pages/OnlineBooking/Payments";
import { useTranslation } from "react-i18next";
import { formatMinor } from "../../Components/Reusable/CurrencyFormatter/CurrencyFormatter";

const timeZoneOptions = [];
Intl.supportedValuesOf("timeZone").forEach((timeZone) => {
  timeZoneOptions.push({ value: timeZone, label: timeZone.split("/")[1] });
});

const Settings = () => {
  const { t, i18n } = useTranslation("settings");
  const { t: a } = useTranslation("auth");
  const { t: c } = useTranslation("choosePlan");
  const { t: d } = useTranslation("onlineBooking");

  // Helpers
  const langLabel = (code) => {
    switch (code) {
      case "es":
        return a("register.language.spanish");
      case "en-GB":
      default:
        return a("register.language.english");
    }
  };
  const relabelSelection = (sel) => (sel ? { value: sel.value, label: langLabel(sel.value) } : sel);

  // Memoized language options (menu contents retranslate)
  const languageOptions = useMemo(
    () => [
      { value: "en-GB", label: a("register.language.english") },
      { value: "es", label: a("register.language.spanish") },
    ],
    [a, i18n.language]
  );

  // Static options that already use t() each render (no memo needed)
  const intervalOptions = [
    { value: 1, label: t("customerisation.calendar.options.interval.m10") },
    { value: 2, label: t("customerisation.calendar.options.interval.m15") },
    { value: 3, label: t("customerisation.calendar.options.interval.m20") },
  ];

  const cancellationThresholds = [
    { value: 0, label: t("customerisation.bookings.options.cancel.noThreshold") },
    { value: 1, label: t("customerisation.bookings.options.cancel.h1") },
    { value: 2, label: t("customerisation.bookings.options.cancel.h2") },
    { value: 3, label: t("customerisation.bookings.options.cancel.h8") },
    { value: 4, label: t("customerisation.bookings.options.cancel.h24") },
    { value: 5, label: t("customerisation.bookings.options.cancel.noCancel") },
  ];

  const bookingThresholds = [
    { value: 0, label: t("customerisation.bookings.options.book.noThreshold") },
    { value: 1, label: t("customerisation.bookings.options.book.h1") },
    { value: 2, label: t("customerisation.bookings.options.book.h2") },
    { value: 3, label: t("customerisation.bookings.options.book.h3") },
    { value: 4, label: t("customerisation.bookings.options.book.h4") },
    { value: 5, label: t("customerisation.bookings.options.book.dayBefore") },
  ];

  const [activeTab, setActiveTab] = useState("Account");
  const [activeSubTab, setActiveSubTab] = useState("Calendar");
  const [activeSubAccountsTab, setActiveSubAccountsTab] = useState("General");
  const [activeSubPrivacyTab, setActiveSubPrivacyTab] = useState("Security");
  const [isLoading, setIsLoading] = useState(true);
  const [config, setConfig] = useState();
  const [hasStripeBalance, setHasStripeBalance] = useState()
  const [paymentServiceDetails, setPaymentServiceDetails] = useState();
  const [interval, setInterval] = useState();
  const [cancellationThreshold, setCancellationThreshold] = useState();
  const [bookingThreshold, setBookingThreshold] = useState();
  const [shopName, setShopName] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [confirmationMessage, setConfirmationMessage] = useState();
  const [notesMessage, setNotesMessage] = useState();
  const [cancellationPolicyMessage, setCancellationPolicyMessage] = useState();
  const [appointmentCancelledMessage, setAppointmentCancelledMessage] = useState();
  const [appointmentChangedMessage, setAppointmentChangedMessage] = useState();
  const [notificationLogon, setNotificationLogon] = useState();
  const [notificationBookingComplete, setNotificationBookingComplete] = useState();
  const [notificationBookingCancelled, setNotificationBookingCancelled] = useState();
  const [currentEmailAddress, setCurrentEmailAddress] = useState();
  const [newEmailAddress, setNewEmailAddress] = useState();
  const [currentPassword, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [newPasswordTwo, setNewPasswordTwo] = useState();
  const [code, setCode] = useState(["", "", "", "", ""]);
  const [showVerficationPopup, setShowVerficationPopup] = useState(false);
  const [verficationType, setVerficationType] = useState("");
  const [codeFull, setCodeFull] = useState(false);
  const [codeInvalid, setCodeInvalid] = useState(false);
  const [updateEmailButton, setUpdateEmailButton] = useState(false);
  const [updateEmailButtonLoading, setUpdateEmailButtonLoading] = useState(false);
  const [updatePasswordButton, setUpdatePasswordButton] = useState(false);
  const [updatePasswordButtonLoading, setUpdatePasswordButtonLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [shopNameEror, setShopNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [status, setStatus] = useState("null");
  const [selectedTimeZone, setSelectedTimeZone] = useState();
  const [detailsSaveButtonLoading, setDetailsSaveButtonLoading] = useState(false);
  const [resetDemoAccountButtonLoading, setResetDemoAccountButtonLoading] = useState(false);
  const [verifyButtonLoading, setVerifyButtonLoading] = useState(false);
  const [saveIntervalButtonLoading, setSaveIntervalButtonLoading] = useState(false);
  const [saveLangButtonLoading, setSaveLangButtonLoading] = useState(false);
  const [saveCalendarButtonLoading, setSaveCalendarButtonLoading] = useState(false);
  const [sendTestEmailLoading, setSendTestEmailLoading] = useState(false);
  const [saveConfirmationEmailLoading, setSaveConfirmationEmailLoading] = useState(false);
  const [saveChangeEmailLoading, setSaveChangeEmailLoading] = useState(false);
  const [breakColour, setBreakColour] = useState("#ffffffff");
  const [membershipLoading, setMembershipLoading] = useState(false);
  const [membershipError, setMembershipError] = useState("");
  const [membership, setMembership] = useState(null);
  const [portalLoading, setPortalLoading] = useState(false);
  const [availablePlans, setAvailablePlans] = useState()
  // Language selects (controlled)
  const [systemLang, setSystemLang] = useState(null);
  const [bookingLang, setBookingLang] = useState(null);
  const [emailLang, setEmailLang] = useState(null);
  const [isBookingPortalAvailable, setIsBookingPortalAvailable] = useState();

  useEffect(() => {
    GetConfigWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Relabel selections whenever the app language changes (instant UI update)
  useEffect(() => {
    const handler = () => {
      setSystemLang((prev) => relabelSelection(prev));
      setBookingLang((prev) => relabelSelection(prev));
      setEmailLang((prev) => relabelSelection(prev));
    };
    i18n.on("languageChanged", handler);
    return () => i18n.off("languageChanged", handler);
  }, [i18n]);

  function GetConfigWrapper() {
    setIsLoading(true);
    GetConfig()
      .then((res) => {
        setCurrentEmailAddress(res.data.shopEmail);
        setConfig(res.data);

        // Set language selections using *current* UI language labels
        setSystemLang({ value: res.data.systemLanguage, label: langLabel(res.data.systemLanguage) });
        setBookingLang({
          value: res.data.bookingPortalLanguage,
          label: langLabel(res.data.bookingPortalLanguage),
        });
        setEmailLang({ value: res.data.emailLanguage, label: langLabel(res.data.emailLanguage) });

        setBreakColour(res.data.calendarBreakColour);
        setShopName(res.data.shopName);
        setSelectedTimeZone(timeZoneOptions.filter((x) => x.value === res.data.timeZone)[0]);
        setPhoneNumber(res.data.phoneNumber);
        setConfirmationMessage(res.data.appointmentConfirmationMessageToCustomer);
        setNotesMessage(res.data.appointmentReminderNotesToCustomer);
        setCancellationPolicyMessage(res.data.appointmentCancellationPolicyToCustomer);
        setAppointmentCancelledMessage(res.data.appointmentCancellationMessageToCustomer);
        setAppointmentChangedMessage(res.data.appointmentChangedMessageToCustomer);
        setNotificationLogon(res.data.notificationLogon);
        setNotificationBookingComplete(res.data.notificationBookingComplete);
        setNotificationBookingCancelled(res.data.notificationBookingCancelled);
        setInterval(
          [{ value: 1 }, { value: 2 }, { value: 3 }]
            .map((o) => ({ ...o, label: intervalOptions.find((x) => x.value === o.value)?.label }))
            .find((x) => x.value === res.data.durationBlock)
        );
        setCancellationThreshold(
          cancellationThresholds.find((x) => x.value === res.data.cancellationThreshold)
        );
        setBookingThreshold(bookingThresholds.find((x) => x.value === res.data.bookingThreshold));
        setCodeFull(false);
        setIsBookingPortalAvailable(res.data.isBookingPortalAvailable)
        setCodeInvalid(false);
        if (!res.data.payoutsEnabled) setStatus("no payouts");
        if (!res.data.chargesEnabled) setStatus("no charges");
        if (res.data.payoutsEnabled && res.data.chargesEnabled) setStatus("Connected");
      })
      .catch(() => {
        notifyError(t("toasts.unableToRetrieve"));
      })
      .finally(() => {
        GetPaymentServiceDetailsWrapper();
      });
  }

    const formatDate = (isoOrNull) => {
    if (!isoOrNull) return "—";
    const d = new Date(isoOrNull);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "2-digit" });
  };

  async function loadMembership() {
    setMembershipError("");
    setMembershipLoading(true);
    try {
      const res = await GetMembershipDetails();
      setMembership(res.data);
    } catch (e) {
      setMembership(null);
      setMembershipError(t('account.membership.errors.loadMembership'));
    } finally {
      setMembershipLoading(false);
      GetAllowedPlansWrapper()
    }
  }

  async function GetAllowedPlansWrapper() {
    try {
      const res = await GetAllowedPlans();
      setAvailablePlans(res.data)
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  }

  async function openBillingPortal() {
    setMembershipError("");
    setPortalLoading(true);
    try {
      const res = await CreateBillingPortalSession();
      const url = res?.data?.url;
      if (url) window.location.href = url;
      else setMembershipError(t('account.membership.errors.billingPortal'));
    } catch (e) {
      setMembershipError(t('account.membership.errors.billingPortal'));
    } finally {
      setPortalLoading(false);
    }
  }

    async function openBillingPortalFromPlanCard() {
    setMembershipError("");
    try {
      const res = await CreateBillingPortalSession();
      const url = res?.data?.url;
      if (url) window.location.href = url;
      else setMembershipError(t('account.membership.errors.billingPortal'));
    } catch (e) {
      setMembershipError(t('account.membership.errors.billingPortal'));
    } finally {
    }
  }


  function GetPaymentServiceDetailsWrapper() {
    GetPaymentServiceDetails().then((res) => {
      if (res.status === 200) {
        setPaymentServiceDetails(res.data);
        const calculateHasStripeBalance =
          (res.data?.availableFunds ?? 0) > 0 ||
          (res.data?.pendingFunds ?? 0) > 0;
                setHasStripeBalance(calculateHasStripeBalance)
      }

      setIsLoading(false);
    }).finally(()=>{
      GetSubscriptionDetailsWrapper()
    })
  }

  function GetSubscriptionDetailsWrapper()
  {
    loadMembership();
  }

  function onCickAppointmentSettingsSave() {
    setSaveIntervalButtonLoading(true);
    PutAppointmentsConfig(cancellationThreshold.value, bookingThreshold.value)
      .then(() => {
        notifySuccess(t("toasts.saved"));
      })
      .catch(() => {
        notifyError(t("toasts.genericSaveError"));
      })
      .finally(() => {
        GetConfigWrapper();
        setSaveIntervalButtonLoading(false);
      });
  }

  async function onCickLangSettingsSave() {
    try {
      setSaveLangButtonLoading(true);
      await PutLangConfig(systemLang.value, bookingLang.value, emailLang.value);
      notifySuccess(t("toasts.saved"));

      // Flip app language and *immediately* relabel current selections
      const lang = systemLang.value || "en-GB";
      await i18n.changeLanguage(lang);

      // Relabel using the *new* language
      setSystemLang((prev) => ({ value: prev.value, label: langLabel(prev.value) }));
      setBookingLang((prev) => ({ value: prev.value, label: langLabel(prev.value) }));
      setEmailLang((prev) => ({ value: prev.value, label: langLabel(prev.value) }));

      localStorage.setItem("ui.lang", lang);
    } catch (e) {
      notifyError(t("toasts.genericSaveError"));
    } finally {
      // Optional: refresh from backend (kept, but not required for the instant relabel)
      GetConfigWrapper();
      setSaveLangButtonLoading(false);
    }
  }

  function onCickCalendarSettingsSave() {
    setSaveCalendarButtonLoading(true);
    PutCalendarConfig(interval.value, breakColour)
      .then(() => {
        notifySuccess(t("toasts.saved"));
      })
      .catch(() => {
        notifyError(t("toasts.genericSaveError"));
      })
      .finally(() => {
        GetConfigWrapper();
        setSaveCalendarButtonLoading(false);
      });
  }

  function onClickSendTestConfirmationEmail() {
    setSendTestEmailLoading(true);
    SendTestConfirmationEmail()
      .then((res) => {
        if (res.status === 200) {
          notifySuccess(t("toasts.testEmailSent"));
        }
      })
      .catch(() => {
        notifyError(t("toasts.genericSaveError"));
      })
      .finally(() => setSendTestEmailLoading(false));
  }

  function onCickAccountDetailsSettingsSave() {
    setShopNameError("");
    setPhoneNumberError("");
    let error = false;
    if (shopName === "" || shopName === undefined || shopName === null) {
      setShopNameError(t("account.details.errors.shopNameRequired"));
      error = true;
    }

    if (!error) {
      setDetailsSaveButtonLoading(true);
      PutAccountDetailsConfig(shopName, phoneNumber, selectedTimeZone.value)
        .then((res) => {
          if (res.status === 200) {
            notifySuccess(t("toasts.saved"));
          }
        })
        .catch(() => {
          notifyError(t("toasts.genericSaveError"));
        })
        .finally(() => {
          setDetailsSaveButtonLoading(false);
          GetConfigWrapper();
        });
    }
  }

  function ResetDemoAccountClick() {
        MyAlert.fire({
          title: t('account.reset.alert.title'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'var(--primary)',
          cancelButtonColor: '#aaa',
          confirmButtonText: t('account.reset.alert.confirm')
        }).then((result) => {
          if (result.isConfirmed) {
            setResetDemoAccountButtonLoading(true)
              ResetDemoAccount()
                .then((res) => {
                  if (res.status === 200) {
                    notifySuccess(t("toasts.DemoAccountResetSuccess"));
                  }
                })
                .catch((err) => {
                  if (err.response.status === 423)
                  {
                    notifyError(t("toasts.DemoAccountResetError"));
                  }
                  else{
                    notifyError(t("toasts.genericSaveError"));
                  }
                })
                .finally(() => {
                  setResetDemoAccountButtonLoading(false);
                  GetConfigWrapper();
                });
          }
          else{
            setResetDemoAccountButtonLoading(false);
          }
        })
  }

  function onCickCustomerisationCommunicationsSettingsSave() {
    setSaveConfirmationEmailLoading(true);
    PutCustomerisationCommunicationsConfig(
      confirmationMessage,
      notesMessage,
      cancellationPolicyMessage,
      appointmentChangedMessage,
      appointmentCancelledMessage
    )
      .then((res) => {
        if (res.status === 200) {
          notifySuccess(t("toasts.saved"));
        }
      })
      .catch(() => {
        notifyError(t("toasts.genericSaveError"));
      })
      .finally(() => {
        setSaveConfirmationEmailLoading(false);
        GetConfigWrapper();
      });
  }

  function onCickCustomerisationCommunicationsSettingsSaveForChangeEmail() {
    setSaveChangeEmailLoading(true);
    PutCustomerisationCommunicationsConfig(
      confirmationMessage,
      notesMessage,
      cancellationPolicyMessage,
      appointmentChangedMessage,
      appointmentCancelledMessage
    )
      .then((res) => {
        if (res.status === 200) {
          notifySuccess(t("toasts.saved"));
        }
      })
      .catch(() => {
        notifyError(t("toasts.genericSaveError"));
      })
      .finally(() => {
        setSaveChangeEmailLoading(false);
        GetConfigWrapper();
      });
  }

  function CurrentEmailAddressHandler(e) {
    setCurrentEmailAddress(e.target.value.toLowerCase());
    if (
      !newEmailAddress ||
      !e.target.value
    ) {
      setUpdateEmailButton(false);
    } else {
      setUpdateEmailButton(true);
    }
  }

  function NewEmailAddressHandler(e) {
    setNewEmailAddress(e.target.value);
    if (!e.target.value || !currentEmailAddress) {
      setUpdateEmailButton(false);
    } else {
      setUpdateEmailButton(true);
    }
  }

  function CurrentPasswordHandler(e) {
    setCurrentPassword(e.target.value);
    if (!newPassword || !newPasswordTwo || !e.target.value) {
      setUpdatePasswordButton(false);
    } else {
      setUpdatePasswordButton(true);
    }
  }

  function NewPasswordHandler(e) {
    setNewPassword(e.target.value);
    if (!e.target.value || !newPasswordTwo || !currentPassword) {
      setUpdatePasswordButton(false);
    } else {
      setUpdatePasswordButton(true);
    }
  }

  function NewPasswordTwoHandler(e) {
    setNewPasswordTwo(e.target.value);
    if (!newPassword || !e.target.value || !currentPassword) {
      setUpdatePasswordButton(false);
    } else {
      setUpdatePasswordButton(true);
    }
  }

  function updateEmailAddressClick(reason) {
    setVerficationType("email update");
    setCode(["", "", "", "", ""]);
    if (currentEmailAddress !== undefined && newEmailAddress !== undefined) {
      if (currentEmailAddress === config.shopEmail.toLowerCase()) {
        if (currentEmailAddress !== newEmailAddress) {
          setUpdateEmailButtonLoading(true);
          VerificationCode(reason, newEmailAddress)
            .then((res) => {
              if (res.status === 200) {
                notifySuccess(t("security.codeSent"));
                setShowVerficationPopup(true);
              }
            })
            .catch((error) => {
              if (error.response?.request?.status === 409) {
                notifyWarn(t("security.emailAlreadyUsed"));
                setShowVerficationPopup(false);
                setVerficationType("");
                setCodeFull(false);
                setCodeInvalid(false);
              } else {
                notifyError(t("security.codeSendErrorEmail"));
              }
            })
            .finally(() => {
              setUpdateEmailButtonLoading(false);
            });
        } else {
          notifyWarn(t("security.newEmailSame"));
        }
      } else {
        notifyWarn(t("security.currentEmailMismatch"));
      }
    }
  }

  function updatePasswordClick(reason) {
    setVerficationType("password update");
    setCode(["", "", "", "", ""]);
    if (newPassword !== newPasswordTwo) {
      setPasswordError(t("security.errors.passwordsDontMatch"));
    } else if (newPassword.length < 8) {
      setPasswordError(t("security.errors.passwordTooShort"));
    } else if (currentPassword === newPassword) {
      setPasswordError(t("security.errors.passwordSameAsCurrent"));
    } else {
      setPasswordError("");
      setUpdatePasswordButtonLoading(true);
      VerificationCode(reason, currentPassword)
        .then((res) => {
          if (res.status === 200) {
            notifySuccess(t("security.codeSent"));
            setShowVerficationPopup(true);
          }
        })
        .catch((error) => {
          if (error.response?.request?.status === 404) {
            notifyWarn(t("security.currentPasswordIncorrect"));
            setShowVerficationPopup(false);
            setVerficationType("");
            setCodeFull(false);
            setCodeInvalid(false);
          } else {
            notifyError(t("security.codeSendErrorGeneric"));
          }
        })
        .finally(() => {
          setUpdatePasswordButtonLoading(false);
        });
    }
  }

  function ResendCode() {
    setCode(["", "", "", "", ""]);
    setCodeFull(false);
    setCodeInvalid(false);
    VerificationCode(
      verficationType,
      verficationType === "email update" ? newEmailAddress : currentPassword
    )
      .then((res) => {
        if (res.status === 200) {
          notifySuccess(t("security.codeSent"));
        }
      })
      .catch(() => {
        notifyError(t("security.codeSendErrorGeneric"));
      })
      .finally(() => {});
  }

  function NotificationOptionHandler(e) {
    if (e.target.id === "logon") {
      setNotificationLogon(e.target.checked);
      PutNotificationsConfig(e.target.id, e.target.checked)
        .then((res) => {
          if (res.status === 200) {
            notifySuccess(t("toasts.saved"));
          }
        })
        .catch(() => {
          notifyError(t("toasts.genericSaveError"));
        });
    }

    if (e.target.id === "completeBooking") {
      setNotificationBookingComplete(e.target.checked);
      PutNotificationsConfig(e.target.id, e.target.checked)
        .then((res) => {
          if (res.status === 200) {
            notifySuccess(t("toasts.saved"));
          }
        })
        .catch(() => {
          notifyError(t("toasts.genericSaveError"));
        });
    }

    if (e.target.id === "cancelBooking") {
      setNotificationBookingCancelled(e.target.checked);
      PutNotificationsConfig(e.target.id, e.target.checked)
        .then((res) => {
          if (res.status === 200) {
            notifySuccess(t("toasts.saved"));
          }
        })
        .catch(() => {
          notifyError(t("toasts.genericSaveError"));
        });
    }
  }

  function VerificationCancelClick() {
    setShowVerficationPopup(false);
    setVerficationType("");
    setCodeFull(false);
    setCodeInvalid(false);
  }

  function VerifyClick() {
    if (verficationType === "email update") {
      setVerifyButtonLoading(true);
      UpdateEmail(currentEmailAddress, newEmailAddress, code)
        .then((res) => {
          if (res.status === 200) {
            notifySuccess(t("security.emailUpdated"));
            setShowVerficationPopup(false);
            setCodeFull(false);
            GetConfigWrapper();
            setUpdateEmailButton(false);
          }
        })
        .catch((error) => {
          if (error.response?.request?.status === 412) {
            setCodeInvalid(true);
          } else {
            notifyError(t("security.emailUpdateError"));
            setShowVerficationPopup(false);
            setVerficationType("");
            setCodeFull(false);
            setCodeInvalid(false);
          }
        })
        .finally(() => {
          setVerifyButtonLoading(false);
        });
    }

    if (verficationType === "password update") {
      setVerifyButtonLoading(true);
      UpdatePassword(currentPassword, newPassword, newPasswordTwo, code)
        .then((res) => {
          if (res.status === 200) {
            notifySuccess(t("security.passwordUpdated"));
            setShowVerficationPopup(false);
            setCodeFull(false);
            GetConfigWrapper();
            setUpdatePasswordButton(false);
          }
        })
        .catch((error) => {
          if (error.response?.request?.status === 412) {
            setCodeInvalid(true);
          } else {
            notifyError(t("security.passwordUpdateError"));
            setShowVerficationPopup(false);
            setVerficationType("");
            setCodeFull(false);
            setCodeInvalid(false);
          }
        })
        .finally(() => {
          setVerifyButtonLoading(false);
        });
    }
  }

      function LiveToggleHandler(e) {
        const next = e.target.checked;
        UpdateBookingPortalStatus(next)
          .then((res) => {
            if (res.status === 200 && next === true) {
              notifySuccess(d("onlineBooking.toasts.bookingPortalOnline"));
              setIsBookingPortalAvailable(true);
            }
            if (res.status === 200 && next === false) {
              notifySuccess(d("onlineBooking.toasts.bookingPortalOffline"));
              setIsBookingPortalAvailable(false);
            }
          })
          .catch((error) => {
              notifyError(d("onlineBooking.toasts.bookingPortalGenericError"));
              setIsBookingPortalAvailable((v) => v);
          })
          .finally(() => {});
      }

  function handleInputChange(index, value) {
    if (index !== 4) {
      simulateTab();
    }
    const newCode = [...code];
    newCode[index] = value.slice(0, 1);
    setCode(newCode);
    setCodeFull(newCode.every((c) => c !== ""));
  }

  function simulateTab() {
    const focusableElements = document.querySelectorAll('input, [tabindex]:not([tabindex="-1"])');
    const elements = Array.from(focusableElements).filter((el) => !el.disabled && el.offsetParent !== null);
    const currentIndex = elements.indexOf(document.activeElement);
    const nextIndex = (currentIndex + 1) % elements.length;
    elements[nextIndex].focus();
  }

  const renderAccountsSubPage = () => {
    switch (activeSubAccountsTab.toLowerCase()) {
      case "general":
        return (
          <div>
            <section className="infoCard">
              <header className="infoHead">
                <h3>{t("account.details.title")}</h3>
                <p className="infoSub">{t("account.details.subtitle")}</p>
              </header>

              <div className="infoBody">
                {/* Shop name */}
                <div className="sm-field">
                  <label className="sm-label" htmlFor="shop-name">
                    {t("account.details.labels.shopName")}
                  </label>
                  <input
                    id="shop-name"
                    type="text"
                    className="sm-input"
                    placeholder={t("account.details.placeholders.shopName")}
                    defaultValue={config.shopName}
                    onChange={(e) => setShopName(e.target.value)}
                  />
                  {shopNameEror ? <div className="sm-error">{shopNameEror}</div> : null}
                </div>

                {/* Phone number */}
                <div className="sm-field">
                  <label className="sm-label" htmlFor="phone-number">
                    {t("account.details.labels.phone")}{" "}
                    <span className="sm-help-inline">{t("account.details.help.phone")}</span>
                  </label>
                  <input
                    id="phone-number"
                    type="tel"
                    className="sm-input"
                    placeholder={t("account.details.placeholders.phone")}
                    defaultValue={config.phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                  {phoneNumberError ? <div className="sm-error">{phoneNumberError}</div> : null}
                </div>

                {/* Time zone */}
                <div className="sm-field">
                  <label className="sm-label" htmlFor="tz">
                    {t("account.details.labels.timeZone")}
                  </label>
                  <Select
                    isSearchable={true}
                    inputId="tz"
                    placeholder={t("account.details.placeholders.timeZone")}
                    closeMenuOnSelect
                    options={timeZoneOptions}
                    defaultValue={selectedTimeZone}
                    onChange={(opt) => setSelectedTimeZone({ value: opt.value, label: opt.label })}
                    className="sm-select"
                    classNamePrefix="rs"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>

                {/* Actions */}
                <div className="infoActions">
                  <CustomButton
                    disabled={detailsSaveButtonLoading}
                    className="app-btn--sm"
                    onClick={onCickAccountDetailsSettingsSave}
                    label={t("common.save")}
                    loading={detailsSaveButtonLoading}
                  />
                </div>
              </div>
            </section>

            {/* Languages section */}
            <section className="schedCard" style={{marginBottom:"18px"}}>
              <header className="schedHead">
                <h3 className="gen-h3">{t("customerisation.languages.system.title")}</h3>
                <p className="schedDesc">{t("customerisation.languages.system.desc")}</p>
              </header>

              <div className="schedBody">
                <div className="schedSelect">
                  <Select
                    isSearchable={false}
                    placeholder={t("customerisation.languages.placeholder")}
                    closeMenuOnSelect
                    options={languageOptions}
                    value={systemLang}
                    onChange={(e) => setSystemLang({ value: e.value, label: langLabel(e.value) })}
                    classNamePrefix="rs"
                  />
                </div>
              </div>

              <header className="schedHead mt-4">
                <h3 className="gen-h3">{t("customerisation.languages.booking.title")}</h3>
                <p className="schedDesc">{t("customerisation.languages.booking.desc")}</p>
              </header>

              <div className="schedBody">
                <div className="schedSelect">
                  <Select
                    isSearchable={false}
                    placeholder={t("customerisation.languages.placeholder")}
                    closeMenuOnSelect
                    options={languageOptions}
                    value={bookingLang}
                    onChange={(e) => setBookingLang({ value: e.value, label: langLabel(e.value) })}
                    classNamePrefix="rs"
                  />
                </div>
              </div>

              <header className="schedHead mt-4">
                <h3 className="gen-h3">{t("customerisation.languages.email.title")}</h3>
                <p className="schedDesc">{t("customerisation.languages.email.desc")}</p>
              </header>

              <div className="schedBody">
                <div className="schedSelect">
                  <Select
                    isSearchable={false}
                    placeholder={t("customerisation.languages.placeholder")}
                    closeMenuOnSelect
                    options={languageOptions}
                    value={emailLang}
                    onChange={(e) => setEmailLang({ value: e.value, label: langLabel(e.value) })}
                    classNamePrefix="rs"
                  />
                </div>

                <p className="sm-hint" style={{ fontSize: "0.9rem" }}>
                  {t("customerisation.languages.email.hint_1")}
                  <a style={{textDecorationLine:"underline"}} onClick={() => {setActiveTab("Customerisation"); setActiveSubTab("Communications")}}>{t("customerisation.languages.email.communication")}</a>
                  {t("customerisation.languages.email.hint_2")}
                </p>
                



                <div className="infoActions mt-2">
                  <CustomButton
                    disabled={saveLangButtonLoading}
                    className="app-btn--sm"
                    onClick={onCickLangSettingsSave}
                    label={t("common.save")}
                    loading={saveLangButtonLoading}
                  />
                </div>
              </div>
            </section>
            {config.demoAccount ?
                        <section className="schedCard">
              <header className="schedHead">
                <h3 className="gen-h3">{t("account.reset.title")}</h3>
                <p className="schedDesc">{t("account.reset.subTitle")}</p>
              </header>

                <div className="infoActions mt-2">
                  <CustomButton
                    disabled={resetDemoAccountButtonLoading}
                    className="app-btn--sm"
                    onClick={ResetDemoAccountClick}
                    label={t("common.reset")}
                    loading={resetDemoAccountButtonLoading}
                  />
                </div>
            </section>
            : null
            }

          </div>

        );
case "membership": {
  const getDaysRemaining = (periodEndUtc) => {
    if (!periodEndUtc) return null;
    const end = new Date(periodEndUtc);
    if (Number.isNaN(end.getTime())) return null;

    const now = new Date();
    const diffMs = end.getTime() - now.getTime();
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return Math.max(0, days);
  };

  const getStatusPresentation = (m) => {
    const raw = (m?.status || "").toLowerCase();
    const isEnding =
      !!membership?.cancelAtPeriodEnd ||
      ["canceled", "cancelled", "canceled_at_period_end"].includes((membership?.status || "").toLowerCase());

    const endsOn = formatDate(m?.currentPeriodEndUtc);
    const dash = t('account.membership.values.dash');

    if (raw === "canceled" || raw === "cancelled" || raw === "canceled_at_period_end" || isEnding) {
      return {
        badgeKey: "ending",
        title: t('account.membership.statusText.endingTitle', { date: endsOn }),
        subtitle: t('account.membership.statusText.endingSubtitle'),
      };
    }

    if (raw === "trial" || raw === "trialing") {
      const daysLeft = getDaysRemaining(m?.currentPeriodEndUtc);
      return {
        badgeKey: "trial",
        title: t('account.membership.statusText.trialTitle'),
        subtitle:
          daysLeft == null
            ? t('account.membership.statusText.endsOn', { date: endsOn })
            : t('account.membership.statusText.daysRemaining', {
                count: daysLeft,
                date: endsOn
              }),
      };
    }

    if (raw === "past_due" || raw === "pastdue" || raw === "unpaid") {
      return {
        badgeKey: "due",
        title: t('account.membership.statusText.paymentDueTitle'),
        subtitle: t('account.membership.statusText.paymentDueSubtitle'),
      };
    }

    if (raw === "active") {
      return {
        badgeKey: "active",
        title: t('account.membership.statusText.activeTitle'),
        subtitle: t('account.membership.statusText.renewsOn', { date: endsOn }),
      };
    }

    return {
      badgeKey: "neutral",
      title: m?.status || t('account.membership.values.unknown'),
      subtitle: endsOn !== dash
        ? t('account.membership.statusText.nextDate', { date: endsOn })
        : "",
    };
  };

  const getNextPaymentText = (m) => {
    const raw = (m?.status || "").toLowerCase();
    const date = formatDate(m?.currentPeriodEndUtc);
    const dash = t('account.membership.values.dash');

    const isEnding =
      !!m?.cancelAtPeriodEnd ||
      ["canceled", "cancelled", "canceled_at_period_end"].includes(raw);

    if (isEnding) {
      return {
        title: t('account.membership.nextPaymentText.noFurtherPaymentsTitle'),
        subtitle: t('account.membership.nextPaymentText.accessEndsSubtitle', { date })
      };
    }

    if (raw === "past_due" || raw === "pastdue" || raw === "unpaid") {
      return {
        title: t('account.membership.nextPaymentText.overdueTitle'),
        subtitle: t('account.membership.nextPaymentText.overdueSubtitle')
      };
    }

    if (raw === "trial" || raw === "trialing") {
      return {
        title: t('account.membership.nextPaymentText.trialEndsTitle', { date }),
        subtitle: t('account.membership.nextPaymentText.trialEndsSubtitle')
      };
    }

    if (raw === "active") {
      return {
        title: t('account.membership.nextPaymentText.nextPaymentDueTitle', { date }),
        subtitle: t('account.membership.nextPaymentText.nextPaymentDueSubtitle')
      };
    }

    return {
      title: date !== dash
        ? t('account.membership.statusText.nextDate', { date })
        : dash,
      subtitle: ""
    };
  };

  const formatReasonText = (plan, usage) => {
    const reasons = plan?.reasons || [];
    if (!reasons.length) return "";

    const parts = reasons.map((reason) => {
      switch (reason) {
        case "too_many_staff":
          return t('account.membership.availablePlans.reasonParts.tooManyStaff', {
            current: usage?.staffCount ?? 0,
            limit: plan.staffLimit
          });
        case "too_many_services":
          return t('account.membership.availablePlans.reasonParts.tooManyServices', {
            current: usage?.serviceCount ?? 0,
            limit: plan.serviceLimit
          });
        case "stripe_balance":
          return t('account.membership.availablePlans.reasonParts.stripeBalance');
        default:
          return t('account.membership.availablePlans.reasonParts.generic');
      }
    });

    if (parts.length === 1) {
      return t('account.membership.availablePlans.reasonSentence.single', { first: parts[0] });
    }

    if (parts.length === 2) {
      return t('account.membership.availablePlans.reasonSentence.double', {
        first: parts[0],
        second: parts[1]
      });
    }

    return t('account.membership.availablePlans.reasonSentence.multiple', {
      allButLast: parts.slice(0, -1).join(", "),
      last: parts[parts.length - 1]
    });
  };

  const statusUI = membership ? getStatusPresentation(membership) : null;
  const isEnding =
    !!membership?.cancelAtPeriodEnd ||
    ["canceled", "cancelled", "canceled_at_period_end"].includes((membership?.status || "").toLowerCase());
  const nextPaymentUI = membership ? getNextPaymentText(membership) : null;

  return (
    <div className="subWrap">
      <section className="subCard">
        <header className="subHead">
          <div className="subHeadText">
            <h2 className="subTitle">{t('account.membership.title')}</h2>
            <div className="subSubRow">
              <p className="subSub">
                {t('account.membership.subtitle')}
              </p>

              {hasStripeBalance && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="membership-balance-warning-tooltip">
                      {t('account.membership.tooltips.starterHiddenBecauseBalance')}
                    </Tooltip>
                  }
                >
                  <span
                    className="sub-cell__warning"
                    aria-label={t('account.membership.tooltips.starterHiddenBecauseBalance')}
                  >
                    <FaExclamationTriangle />
                  </span>
                </OverlayTrigger>
              )}
            </div>
          </div>

          <div className="subActions">
            <button
              type="button"
              className="subBtn subBtn--ghost"
              onClick={loadMembership}
              disabled={membershipLoading}
            >
              {membershipLoading
                ? t('account.membership.actions.refreshing')
                : t('account.membership.actions.refresh')}
            </button>

            <button
              type="button"
              className="subBtn subBtn--primary"
              onClick={openBillingPortal}
              disabled={portalLoading}
            >
              {portalLoading
                ? t('account.membership.actions.opening')
                : t('account.membership.actions.manageBilling')}
            </button>
          </div>
        </header>

        {isEnding && membership && !membershipLoading ? (
          <div className="subBanner subBanner--danger" role="status" aria-live="polite">
            <div className="subBannerTitle">
              {t('account.membership.banner.endsOn', {
                date: formatDate(membership.currentPeriodEndUtc)
              })}
            </div>
            <div className="subBannerText">
              {t('account.membership.banner.renewTextPrefix')}{' '}
              <button type="button" className="subLinkBtn" onClick={openBillingPortal}>
                {t('account.membership.actions.renewHere')}
              </button>
              .
            </div>
          </div>
        ) : null}

        {membershipError ? (
          <div className="subAlert subAlert--error">
            <div className="subAlertTitle">
              {t('account.membership.alerts.genericErrorTitle')}
            </div>
            <div className="subAlertText">{membershipError}</div>
          </div>
        ) : null}

        {!membership && !membershipLoading ? (
          <div className="subEmpty">
            <div className="subEmptyTitle">{t('account.membership.empty.title')}</div>
            <div className="subEmptyText">{t('account.membership.empty.text')}</div>
          </div>
        ) : null}

        {membershipLoading ? (
          <div className="subSkeleton">
            <div className="subSkLine subSkLine--lg" />
            <div className="subSkGrid">
              <div className="subSkCard" />
              <div className="subSkCard" />
              <div className="subSkCard" />
            </div>
          </div>
        ) : null}

        {membership && !membershipLoading ? (
          <div className="subBody">
            <div className="subGrid">
              <div className="subTile">
                <div className="subLabel">{t('account.membership.labels.plan')}</div>
                <div className="subValue">
                  <span className="subPill">
                    {membership.planName || t('account.membership.values.dash')}
                  </span>
                </div>
                <div className="subMeta">{c(`plans.${membership.tier}.planDescription`)}</div>
              </div>

              <div className="subTile">
                <div className="subLabel">{t('account.membership.labels.billing')}</div>
                <div className="subValue">
                  {membership.priceMinor != null
                    ? `${formatMinor(membership.priceMinor, membership.currency)} ${t('account.membership.values.perMonth')} ${t('account.membership.values.vatNotice')}`
                    : t('account.membership.values.dash')}
                </div>
                <div className="subMeta">{t('account.membership.meta.billingCurrency')}</div>
              </div>

              <div className="subTile">
                <div className="subLabel">{t('account.membership.labels.status')}</div>
                <div className="subValue">
                  <span className={`subBadge subBadge--${statusUI?.badgeKey || 'neutral'}`}>
                    {statusUI?.title || t('account.membership.values.dash')}
                  </span>
                </div>
                {statusUI?.subtitle ? <div className="subMeta">{statusUI.subtitle}</div> : null}
              </div>

              <div className="subTile">
                <div className="subLabel">{t('account.membership.labels.nextPayment')}</div>
                <div className="subValue">
                  {nextPaymentUI?.title || t('account.membership.values.dash')}
                </div>
                {nextPaymentUI?.subtitle ? <div className="subMeta">{nextPaymentUI.subtitle}</div> : null}
              </div>
            </div>

            <div className="subNote">
              {t('account.membership.meta.portalNote')}
            </div>

            {availablePlans?.plans?.length ? (
              <section className="availPlansCard">
                <div className="availPlansHead">
                  <div>
                    <h3 className="availPlansTitle">
                      {t('account.membership.availablePlans.title')}
                    </h3>
                    <p className="availPlansSub">
                      {t('account.membership.availablePlans.subtitle')}
                    </p>
                  </div>

                  {/* <div className="availPlansUsage">
                    <span className="availPlansUsagePill">
                      {t('account.membership.availablePlans.usage.staff', {
                        count: availablePlans.staffCount
                      })}
                    </span>
                    <span className="availPlansUsagePill">
                      {t('account.membership.availablePlans.usage.services', {
                        count: availablePlans.serviceCount
                      })}
                    </span>
                    {availablePlans.stripeConnected ? (
                      <span className="availPlansUsagePill">
                        {t('account.membership.availablePlans.usage.stripeConnected')}
                      </span>
                    ) : null}
                  </div> */}
                </div>

                <div className="availPlansGrid">
                  {availablePlans.plans.map((plan) => {
                    const isCurrent = plan.tier === availablePlans.currentPlan;
                    const isUnavailable = !plan.available;
                    const reasonText = formatReasonText(plan, availablePlans);

                    return (
                      <div
                        key={plan.tier}
                        className={[
                          "availPlanTile",
                          isCurrent ? "availPlanTile--current" : "",
                          isUnavailable ? "availPlanTile--unavailable" : ""
                        ].join(" ")}
                          onClick={() => {
                          if (isUnavailable || isCurrent) return;
                          openBillingPortalFromPlanCard();
  }}
                      >
                        <div className="availPlanTop">
                          <div>
                            <div className="availPlanNameRow">
                              <h4 className="availPlanName">
                                {c(`plans.${plan.tier}.title`)}
                              </h4>

                              {isCurrent ? (
                                <span className="availPlanBadge availPlanBadge--current">
                                  {t('account.membership.availablePlans.badges.current')}
                                </span>
                              ) : null}

                              {isUnavailable ? (
                                <span className="availPlanBadge availPlanBadge--muted">
                                  {t('account.membership.availablePlans.badges.unavailable')}
                                </span>
                              ) : (
                                <span className="availPlanBadge availPlanBadge--ok">
                                  {t('account.membership.availablePlans.badges.available')}
                                </span>
                              )}
                            </div>

                            <div className="availPlanPrice">
                              {formatMinor(plan.priceMinor, membership?.currency || "GBP")}
                              <span className="availPlanPriceSuffix">
                                {c(`plans.${plan.tier}.period`)} {t('account.membership.values.vatNotice')}
                              </span>
                            </div>
                          </div>
                        </div>

                      <div className="availPlanMeta">
                        <span>
                          {t('account.membership.availablePlans.limits.staff', {
                            count: plan.staffLimit
                          })}
                        </span>

                        <span>
                          {t('account.membership.availablePlans.limits.services', {
                            count: plan.serviceLimit
                          })}
                        </span>

                        {plan.miniSiteFeature && (
                          <span>
                            {t('account.membership.availablePlans.features.miniSite')}
                          </span>
                        )}

                        {plan.onlinePaymentsFeature && (
                          <span>
                            {t('account.membership.availablePlans.features.onlinePayments')}
                          </span>
                        )}
                      </div>

                        <div className="availPlanDesc">
                          {c(`plans.${plan.tier}.planDescription`)}
                        </div>

                        {isUnavailable && reasonText ? (
                          <div className="availPlanReason">
                            <FaExclamationTriangle className="availPlanReasonIcon" />
                            <span>{reasonText}</span>
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </section>
            ) : null}
          </div>
        ) : null}
      </section>
    </div>
  );
}
      case "payments":
        return (
          <Payments
            setLoading={setIsLoading}
            getConfig={GetConfigWrapper}
            paymentServiceDetails={paymentServiceDetails}
            status={status}
            config={config}
            ShowBookingPortalLink={false}
            ShowPaymentPanel={true}
          />
        );
      default:
        return null;
    }
  };

  const renderPrivacySubPage = () => {
    switch (activeSubPrivacyTab.toLowerCase()) {
      case "security":
        return (
          <>
            <div className="acctWrap">
              <section className="settingsCard">
                <header className="settingsHead">
                  <h3 className="settingsTitle">{t("security.email.title")}</h3>
                  <p className="settingsSub">{t("security.email.subtitle")}</p>
                </header>
                <div className="settingsBody">
                  <div className="setField">
                    <label className="setLabel">
                      {t("security.email.labels.current")} <span className="sm-req">*</span>
                    </label>
                    <input
                      type="email"
                      className="setInput"
                      placeholder={t("security.email.placeholders.current")}
                      defaultValue={config.shopEmail}
                      onChange={CurrentEmailAddressHandler}
                    />
                  </div>

                  <div className="setField">
                    <label className="setLabel">
                      {t("security.email.labels.new")} <span className="sm-req">*</span>
                    </label>
                    <input
                      type="email"
                      className="setInput"
                      placeholder={t("security.email.placeholders.new")}
                      onChange={NewEmailAddressHandler}
                    />
                  </div>

                  <div className="infoActions">
                    <CustomButton
                      disabled={!updateEmailButton}
                      className="app-btn--sm"
                      onClick={() => updateEmailAddressClick("email update")}
                      label={t("security.email.actions.update")}
                      loading={updateEmailButtonLoading}
                    />
                  </div>
                </div>
              </section>

              <section className="settingsCard">
                <header className="settingsHead">
                  <h3 className="settingsTitle">{t("security.password.title")}</h3>
                  <p className="settingsSub">{t("security.password.subtitle")}</p>
                </header>

                <div className="settingsBody">
                  <div className="setField">
                    <label className="setLabel">
                      {t("security.password.labels.current")} <span className="sm-req">*</span>
                    </label>
                    <input
                      type="password"
                      className="setInput password-input"
                      placeholder={t("security.password.placeholders.current")}
                      onChange={CurrentPasswordHandler}
                    />
                  </div>

                  <div className="setField">
                    <label className="setLabel">
                      {t("security.password.labels.new")} <span className="sm-req">*</span>
                    </label>
                    <input
                      type="password"
                      className="setInput password-input"
                      placeholder={t("security.password.placeholders.new")}
                      onChange={NewPasswordHandler}
                    />
                  </div>

                  <div className="setField">
                    <label className="setLabel">
                      {t("security.password.labels.reenter")} <span className="sm-req">*</span>
                    </label>
                    <input
                      type="password"
                      className="setInput password-input"
                      placeholder={t("security.password.placeholders.reenter")}
                      onChange={NewPasswordTwoHandler}
                    />
                  </div>

                  {passwordError !== "" && <p className="setError">{passwordError}</p>}

                  <div className="infoActions">
                    <CustomButton
                      disabled={!updatePasswordButton}
                      className="app-btn--sm"
                      onClick={() => updatePasswordClick("password update")}
                      label={t("security.password.actions.update")}
                      loading={updatePasswordButtonLoading}
                    />
                  </div>
                </div>
              </section>
            </div>

            {showVerficationPopup ? (
              <div className="verifyOverlay">
                <div className="verifyCard">
                  <h2 className="verifyTitle">{t("security.verify.title")}</h2>
                  <p className="verifySub">
                    {verficationType === "email update"
                      ? t("security.verify.sentToNew")
                      : t("security.verify.sentToCurrent")}
                  </p>

                  <div className="codeBoxes">
                    {code.map((value, index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength="1"
                        value={value}
                        onChange={(e) => handleInputChange(index, e.target.value.toUpperCase())}
                        className="code-slot"
                        autoFocus={index === 0}
                      />
                    ))}
                  </div>

                  {codeInvalid && (
                    <div className="verifyInline">
                      <p className="verifyErr">{t("security.verify.invalidCode")}</p>
                      <button onClick={ResendCode} className="cancel-btn button2">
                        {t("common.resend")}
                      </button>
                    </div>
                  )}

                  <div className="verifyActions">
                    <BackButton label={t("common.cancel")} loading={false} onClick={VerificationCancelClick}></BackButton>
                    <CustomButton
                      disabled={!codeFull}
                      className="app-btn--sm"
                      onClick={VerifyClick}
                      label={t("common.verify")}
                      loading={verifyButtonLoading}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div />
            )}
          </>
        );
      case "policies":
        return (
          <>
            <PoliciesPage config={config} orgAcceptedAt={config.shopCreatedAt} orgAcceptedBy={config.shopEmail} />
          </>
        );
      default:
        return null;
    }
  };

  const renderAnalyticsSubPage = () => {
    switch (activeSubTab.toLowerCase()) {
      case "calendar":
        return (
          <>
            <section className="schedCard">
              <header className="schedHead">
                <h3 className="gen-h3">{t("customerisation.calendar.titleBreak")}</h3>
                <p className="schedDesc">{t("customerisation.calendar.descBreak")}</p>
              </header>
              <div className="schedBody">
                <ColorPickerField
                  label=""
                  value={breakColour}
                  onChange={setBreakColour}
                  closeOnSelect={true}
                  applyOnDrag={true}
                />
              </div>

              <header style={{marginTop:"1rem"}} className="schedHead">
                <h3 className="gen-h3">{t("customerisation.calendar.titleInterval")}</h3>
                <p className="schedDesc">{t("customerisation.calendar.descInterval")}</p>
              </header>

              <div className="schedBody">
                <div className="schedSelect">
                  <Select
                    isSearchable={false}
                    placeholder={t("customerisation.calendar.placeholders.interval")}
                    closeMenuOnSelect
                    options={intervalOptions}
                    value={interval}
                    onChange={(e) => setInterval({ value: e.value, label: e.label })}
                    classNamePrefix="rs"
                  />
                </div>

                <p className="schedWarning">{t("customerisation.calendar.warning")}</p>
              </div>

              <div className="infoActions mt-2">
                <CustomButton
                  disabled={saveCalendarButtonLoading}
                  className="app-btn--sm"
                  onClick={onCickCalendarSettingsSave}
                  label={t("common.save")}
                  loading={saveCalendarButtonLoading}
                />
              </div>
            </section>
          </>
        );
      case "bookings":
        return (
          <>
                        <div style={{marginBottom:"20px"}} className="mini-card-general gen-card">
                <div className="gen-toggleRow">
                  <div className="gen-toggleText">
                    <h3 className="gen-h3">{d("onlineBooking.bookingPortal.title")}</h3>
                    <p className="gen-muted">{d("onlineBooking.bookingPortal.description")}</p>
                  </div>

                  {/* Accessible switch */}
                  <div className="sectionToggle">
                    <input
                      className="toggle-switch"
                      type="checkbox"
                      checked={isBookingPortalAvailable}
                      id="live-toggle"
                      onChange={LiveToggleHandler}
                      // aria-label={t("labels.liveToggle")}
                    />
                    <label htmlFor="live-toggle" className="switch-label" />
                  </div>
                </div>
              </div>
            <section className="schedCard">
              <header className="schedHead">
                <h3 className="gen-h3">{t("customerisation.bookings.titleBooking")}</h3>
                <p className="schedDesc">{t("customerisation.bookings.descBooking")}</p>
              </header>

              <div className="schedBody">
                <div className="schedSelect">
                  <Select
                    isSearchable={false}
                    placeholder={t("customerisation.bookings.placeholders.booking")}
                    closeMenuOnSelect
                    options={bookingThresholds}
                    defaultValue={bookingThreshold}
                    onChange={(e) => setBookingThreshold({ value: e.value, label: e.label })}
                    classNamePrefix="rs"
                  />
                </div>
              </div>

              <header className="schedHead mt-4">
                <h3 className="gen-h3">{t("customerisation.bookings.titleCancel")}</h3>
                <p className="schedDesc">{t("customerisation.bookings.descCancel")}</p>
              </header>

              <div className="schedBody">
                <div className="schedSelect">
                  <Select
                    isSearchable={false}
                    placeholder={t("customerisation.bookings.placeholders.cancel")}
                    closeMenuOnSelect
                    options={cancellationThresholds}
                    value={cancellationThreshold}
                    onChange={(e) => setCancellationThreshold({ value: e.value, label: e.label })}
                    classNamePrefix="rs"
                  />
                </div>
                <p className="sm-hint" style={{ fontSize: "0.9rem" }}>
                  {t("customerisation.bookings.hintSupersede")}
                </p>
                <div className="infoActions mt-2">
                  <CustomButton
                    disabled={saveIntervalButtonLoading}
                    className="app-btn--sm"
                    onClick={onCickAppointmentSettingsSave}
                    label={t("common.save")}
                    loading={saveIntervalButtonLoading}
                  />
                </div>
              </div>
            </section>
          </>
        );
      case "communications":
        return (
          <>
            {/* Intro */}
            <section className="commCard">
              <header className="commHead">
                <h3 className="commTitle">{t("customerisation.comms.title")}</h3>
                <p className="commSub">{t("customerisation.comms.subtitle")}</p>
              </header>

              <div className="commBody">
                {/* Token helper */}
                <div className="commHint">
                  <p className="commHint__title">{t("customerisation.comms.tokens.title")}</p>
                  <ul className="tokenList">
                    <li>
                      <span className="tokenChip">#staffName#</span> {t("customerisation.comms.tokens.staffName")}
                    </li>
                    <li>
                      <span className="tokenChip">#date#</span> {t("customerisation.comms.tokens.date")}
                    </li>
                    <li>
                      <span className="tokenChip">#time#</span> {t("customerisation.comms.tokens.time")}
                    </li>
                  </ul>
                </div>

                {/* Confirmation section */}
                <div className="commBlock">
                  <h4 className="commBlock__title">{t("customerisation.comms.confirmation.title")}</h4>

                  <div className="sm-field">
                    <label className="sm-label">{t("customerisation.comms.common.message")}</label>
                    <textarea
                      className="sm-textarea"
                      maxLength={300}
                      rows={4}
                      placeholder={t("customerisation.comms.confirmation.placeholders.message")}
                      defaultValue={config.appointmentConfirmationMessageToCustomer}
                      onChange={(e) => setConfirmationMessage(e.target.value)}
                    />
                  </div>

                  <div className="sm-field">
                    <label className="sm-label">{t("customerisation.comms.common.notes")}</label>
                    <textarea
                      className="sm-textarea"
                      maxLength={300}
                      rows={4}
                      placeholder={t("customerisation.comms.confirmation.placeholders.notes")}
                      defaultValue={config.appointmentReminderNotesToCustomer}
                      onChange={(e) => setNotesMessage(e.target.value)}
                    />
                  </div>

                  <div className="sm-field">
                    <label className="sm-label">{t("customerisation.comms.common.cancellationPolicy")}</label>
                    <textarea
                      className="sm-textarea"
                      maxLength={300}
                      rows={4}
                      placeholder={t("customerisation.comms.confirmation.placeholders.policy")}
                      defaultValue={config.appointmentCancellationPolicyToCustomer}
                      onChange={(e) => setCancellationPolicyMessage(e.target.value)}
                      style={{ justifyContent: "center" }}
                    />
                  </div>

                  <div className="commActions commActions--split">
                    <BackButton
                      style={{ justifyContent: "center" }}
                      label={t("customerisation.comms.actions.sendTest")}
                      onClick={onClickSendTestConfirmationEmail}
                      disabled={sendTestEmailLoading}
                      loading={sendTestEmailLoading}
                    ></BackButton>
                    <CustomButton
                      disabled={saveConfirmationEmailLoading}
                      className="app-btn--sm"
                      onClick={onCickCustomerisationCommunicationsSettingsSave}
                      label={t("common.save")}
                      loading={saveConfirmationEmailLoading}
                    />
                  </div>
                </div>
              </div>
            </section>

            {/* Amendments */}
            <section className="commCard mt-4">
              <header className="commHead">
                <h3 className="commTitle">{t("customerisation.comms.amendments.title")}</h3>
                <p className="commSub">{t("customerisation.comms.amendments.subtitle")}</p>
              </header>

              <div className="commBody">
                <div className="sm-field">
                  <label className="sm-label">
                    {t("customerisation.comms.amendments.labels.cancelDefault")}
                  </label>
                  <textarea
                    className="sm-textarea"
                    maxLength={300}
                    rows={4}
                    placeholder={t("customerisation.comms.amendments.placeholders.cancel")}
                    defaultValue={config.appointmentCancellationMessageToCustomer}
                    onChange={(e) => setAppointmentCancelledMessage(e.target.value)}
                  />
                </div>

                <div className="sm-field">
                  <label className="sm-label">
                    {t("customerisation.comms.amendments.labels.changeDefault")}
                  </label>

                  <textarea
                    className="sm-textarea"
                    maxLength={300}
                    rows={4}
                    placeholder={t("customerisation.comms.amendments.placeholders.change")}
                    defaultValue={config.appointmentChangedMessageToCustomer}
                    onChange={(e) => setAppointmentChangedMessage(e.target.value)}
                  />
                                                    <p className="sm-hint" style={{ fontSize: "0.9rem" }}>
                  {t("customerisation.comms.amendments.labels.hint")}
                </p>
                </div>

                <div className="infoActions">
                  <CustomButton
                    disabled={saveChangeEmailLoading}
                    className="app-btn--sm"
                    onClick={onCickCustomerisationCommunicationsSettingsSaveForChangeEmail}
                    label={t("common.save")}
                    loading={saveChangeEmailLoading}
                  />
                </div>
              </div>
            </section>
          </>
        );
      case "notifications":
        return (
          <>
            <section className="notifCard">
              <header className="notifHead">
                <h3 className="notifTitle">{t("customerisation.notifications.title")}</h3>
                <p className="notifSub">{t("customerisation.notifications.subtitle")}</p>
              </header>

              <div className="notifBody">
                {/* Logon */}
                <div className="notifRow">
                  <div className="notifRow__text">
                    <span className="notifLabel">{t("customerisation.notifications.labels.logon")}</span>
                  </div>
                  <div className="notifRow__control">
                    <input
                      onChange={(e) => {
                        NotificationOptionHandler(e);
                      }}
                      className="toggle-switch"
                      type="checkbox"
                      defaultChecked={false}
                      checked={notificationLogon}
                      id="logon"
                    />
                    <label htmlFor="logon" className="switch-label" />
                  </div>
                </div>

                {/* Booking complete */}
                <div className="notifRow">
                  <div className="notifRow__text">
                    <span className="notifLabel">{t("customerisation.notifications.labels.complete")}</span>
                  </div>
                  <div className="notifRow__control">
                    <input
                      onChange={(e) => {
                        NotificationOptionHandler(e);
                      }}
                      className="toggle-switch"
                      type="checkbox"
                      defaultChecked={false}
                      id="completeBooking"
                      checked={notificationBookingComplete}
                    />
                    <label htmlFor="completeBooking" className="switch-label" />
                  </div>
                </div>

                {/* Booking cancelled */}
                <div className="notifRow">
                  <div className="notifRow__text">
                    <span className="notifLabel">{t("customerisation.notifications.labels.cancel")}</span>
                  </div>
                  <div className="notifRow__control">
                    <input
                      onChange={(e) => {
                        NotificationOptionHandler(e);
                      }}
                      className="toggle-switch"
                      type="checkbox"
                      defaultChecked={false}
                      id="cancelBooking"
                      checked={notificationBookingCancelled}
                    />
                    <label htmlFor="cancelBooking" className="switch-label" />
                  </div>
                </div>
              </div>
            </section>
          </>
        );
      default:
        return null;
    }
  };

  const renderContent = () => {
    switch (activeTab.toLowerCase()) {
      case "account":
        return (
          <>
            <div className="sub-nav">
              {["General", "Membership", "Payments"].map((tab) => (
                <a
                  key={tab}
                  href="#"
                  className={`sub-tab ${activeSubAccountsTab === tab ? "active" : ""}`}
                  onClick={() => setActiveSubAccountsTab(tab)}
                >
                  {t(`nav.account.${tab.toLowerCase()}`)}
                </a>
              ))}
            </div>
            {renderAccountsSubPage()}
          </>
        );
      case "privacy":
        return (
          <>
            <div className="sub-nav">
              {["Security", "Policies"].map((tab) => (
                <a
                  key={tab}
                  href="#"
                  className={`sub-tab ${activeSubPrivacyTab === tab ? "active" : ""}`}
                  onClick={() => setActiveSubPrivacyTab(tab)}
                >
                  {t(`nav.privacy.${tab.toLowerCase()}`)}
                </a>
              ))}
            </div>
            {renderPrivacySubPage()}
          </>
        );
      case "customerisation":
        return (
          <>
            <div className="sub-nav">
              {["Calendar", "Bookings", "Communications", "Notifications"].map((tab) => (
                <a
                  key={tab}
                  href="#"
                  className={`sub-tab ${activeSubTab === tab ? "active" : ""}`}
                  onClick={() => setActiveSubTab(tab)}
                >
                  {t(`nav.customerisation.${tab.toLowerCase()}`)}
                </a>
              ))}
            </div>
            {renderAnalyticsSubPage()}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <ToastContainer />
      {isLoading ? (
        <div className="custom-loader-wrapper">
          <div className="custom-loader"></div>
        </div>
      ) : (
        <div style={{ marginTop: 0, paddingTop: 0 }} className="container">
          <header className="setting-header">
            <nav className="main-nav">
              {["Account", "Privacy", "Customerisation"].map((tab) => (
                <a
                  key={tab}
                  href="#"
                  className={`tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {t(`nav.main.${tab.toLowerCase()}`)}
                </a>
              ))}
            </nav>
          </header>
          {renderContent()}
        </div>
      )}
    </div>
  );
};

export default Settings;
